import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { Product } from 'src/typings';
import { ProductService } from '../product.service';

@Component({
  selector: 'app-new-selector',
  templateUrl: './new-selector.component.html',
  styleUrls: ['./new-selector.component.scss']
})
export class NewSelectorComponent {
  @Input() multi: boolean = false;

  @Input() selected:
    | Product[]
    | { product: Product; quan: number }[]
    | { product: Product; quan: number; price: number } = [];

  @Output() toggleEvent = new EventEmitter<Product>();

  products: Product[] = [];

  loading: boolean = false;

  searchForm = this.fb.group({
    search_keys: new FormControl('mahle lx'),
    limit: new FormControl<number>(30),
    offset: new FormControl<number>(0),
    sort_active: new FormControl<string>('description'),
    sort_direction: new FormControl<string>('asc')
  });

  constructor(private productService: ProductService, private fb: FormBuilder) {
    this.search();
  }

  toggle(product: Product) {
    this.toggleEvent.emit(product);
  }

  get searchControlValue() {
    return this.searchForm.controls.search_keys;
  }

  async search() {
    this.loading = true;
    const res = await firstValueFrom(this.productService.search(this.searchForm.value));
    this.products = res.data;
    this.loading = false;
  }
}
